import { render } from "./ExpectedGraduatesByYearChart.vue?vue&type=template&id=54ac824b&scoped=true"
import script from "./ExpectedGraduatesByYearChart.vue?vue&type=script&lang=js"
export * from "./ExpectedGraduatesByYearChart.vue?vue&type=script&lang=js"

import "./ExpectedGraduatesByYearChart.vue?vue&type=style&index=0&id=54ac824b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-54ac824b"

export default script